module.exports = __webpack_public_path__ + "files/7706111770fb981c1f4efbb462ca5f57.png";